export const loading = (state) => state.cashback.loading;
export const balance = (state) => state.cashback.balance;
export const transactions = (state) => state.cashback.transactions;
export const hasMore = (state) => state.cashback.hasMore;
export const loadingMore = (state) => state.cashback.loadingMore;
export const messages = (state) => state.cashback.messages;
